export default __webpack_public_path__ + "static/media/ExpressingFeelings_00.77e6d049.png";